export interface RheaTheme {
  colors: {
    background: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
    text: {
      primary: string;
      secondary: string;
      accent: string;
    };
    card: {
      background: string;
      hover: string;
      border: string;
    };
    accent: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
  };
}

export const defaultRheaTheme: RheaTheme = {
  colors: {
    background: {
      primary: '#0f0f0f',    // Very dark background
      secondary: '#1a1a1a',  // Slightly lighter background
      tertiary: '#2d2d2d',   // Even lighter background
    },
    text: {
      primary: '#ffffff',    // Pure white text for maximum contrast
      secondary: '#d1d5db',  // Light gray text for better readability
      accent: '#60a5fa',     // Blue accent
    },
    card: {
      background: '#1a1a1a', // Card background
      hover: '#2d2d2d',      // Card hover state
      border: '#374151',     // Card border - darker for better definition
    },
    accent: {
      primary: '#60a5fa',    // Primary accent (blue)
      secondary: '#34d399',  // Secondary accent (green)
      tertiary: '#f472b6',   // Tertiary accent (pink)
    },
  },
};

// CSS variable names for the theme
export const rheaThemeVars = {
  colors: {
    background: {
      primary: '--rhea-bg-primary',
      secondary: '--rhea-bg-secondary',
      tertiary: '--rhea-bg-tertiary',
    },
    text: {
      primary: '--rhea-text-primary',
      secondary: '--rhea-text-secondary',
      accent: '--rhea-text-accent',
    },
    card: {
      background: '--rhea-card-bg',
      hover: '--rhea-card-hover',
      border: '--rhea-card-border',
    },
    accent: {
      primary: '--rhea-accent-primary',
      secondary: '--rhea-accent-secondary',
      tertiary: '--rhea-accent-tertiary',
    },
  },
}; 